import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { DialogActions as MuiDialogAction } from '@material-ui/core';
import { ButtonPanelGroup } from './ButtonPanelGroup';

export type IActionVariant = 'decisions' | 'primary' | 'secondary' | 'outline' | 'link' | 'material';

export interface IActionsProps {
  id?: string;
  name: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent<Element>) => void;
  isDisabled?: boolean;
  className?: string;
  styles?: CSSProperties;
  /**
   * @default "right"
   */
  position?: 'left' | 'right';
  tabIndex?: number;
  key?: string;
}

export interface IButtonPanelProps {
  className?: string;
  style?: CSSProperties;
  actions?: IActionsProps[];
  /**
   * Use decisions button style instead of material-ui button style
   *
   * @default decisions
   */
  variant?: IActionVariant;
  /**
   * Removes paddings around panel. It is useful when container has its own padding.
   */
  disablePadding?: boolean;
}

/**
 * Displays buttons on the left and right sides
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function ButtonPanel({ actions, className, style, variant, disablePadding }: IButtonPanelProps) {
  const leftActions = (actions ?? []).filter(item => item.position === 'left');
  const rightActions = (actions ?? []).filter(item => item.position !== 'left');

  return (
    <MuiDialogAction
      className={classNames(
        'dp-button-panel',
        {
          'dp-button-panel--disable-padding': disablePadding,
        },
        className
      )}
      style={style}
      disableSpacing
    >
      {leftActions.length !== 0 && <ButtonPanelGroup position="left" actions={leftActions} variant={variant} />}
      {rightActions.length !== 0 && <ButtonPanelGroup position="right" actions={rightActions} variant={variant} />}
    </MuiDialogAction>
  );
}
